import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { VisitType } from '../models/vistit-type.model';
import { Observable } from 'rxjs';
import { GiveawayItem } from '../../lookups/models/giveaway-item.model';

@Injectable({
  providedIn: 'root'
})
export class VisitsApiService {

  constructor(protected readonly http: HttpClient,
    private readonly configurations: ConfigurationService) { }

  getVisitTypes(): Observable<VisitType[]> {
    return this.http.get<VisitType[]>(`${this.configurations.apiAddress}/api/visitTypes/getAll`);
  }

  getVisitChannels(): Observable<VisitType[]> {
    return this.http.get<VisitType[]>(`${this.configurations.apiAddress}/api/VisitChannels/getAll`);
  }

  addVisit(visit) {
    return this.http.post(`${this.configurations.apiAddress}/api/visits/addVisit`, visit);
  }

  saveVisit(visit) {
    return this.http.post(`${this.configurations.apiAddress}/api/visits/saveVisit`, visit);
  }

  searchVisits(dateFrom, dateTo, userId?) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('searcehUserId', userId == undefined ? "" : userId);
    return this.http.get(`${this.configurations.apiAddress}/api/visits/searchVisits`, { params: myParams })
  }

  searchVisitsPaging(dateFrom, dateTo, pageSize, pageNumber, userId?) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('pageSize', pageSize)
      .set('pageNumber', pageNumber)
      .set('searcehUserId', userId == undefined ? "" : userId);
    return this.http.get(`${this.configurations.apiAddress}/api/visits/searchVisitsPaging`, { params: myParams })
  }

  getById(id: number) {
    return this.http.get(`${this.configurations.apiAddress}/api/visits/getById/${id}`);
  }
  delete(id: number) {
    return this.http.delete(`${this.configurations.apiAddress}/api/visits/delete/${id}`);
  }
  getGiveawayItems(): Observable<GiveawayItem[]> {
    return this.http.get<GiveawayItem[]>(`${this.configurations.apiAddress}/api/giveawayItem/getAll`);

  }

  approveVisit(id: number) {
    return this.http.get(`${this.configurations.apiAddress}/api/visits/approveVisit/${id}`);
  }
  rejectVisit(id: number) {
    return this.http.get(`${this.configurations.apiAddress}/api/visits/rejectVisit/${id}`);
  }

  getHcpVisits(dateFrom, dateTo, hcpId?) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('hcpId', hcpId == undefined ? "" : hcpId);
    return this.http.get(`${this.configurations.apiAddress}/api/visits/getHcpVisits`, { params: myParams })
  }

  getHcoVisits(dateFrom, dateTo, hcoId?) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('hcoId', hcoId == undefined ? "" : hcoId);
    return this.http.get(`${this.configurations.apiAddress}/api/visits/getHcoVisits`, { params: myParams })
  }

  getTotalHcpVisitsCount(hcpId?) {
    let myParams = new HttpParams()
      .set('hcpId', hcpId == undefined ? "" : hcpId);
    return this.http.get(`${this.configurations.apiAddress}/api/visits/getTotalHcpVisitsCount`, { params: myParams })
  }

  getTotalHcoVisitsCount(hcoId?) {
    let myParams = new HttpParams()
      .set('hcoId', hcoId == undefined ? "" : hcoId);
    return this.http.get(`${this.configurations.apiAddress}/api/visits/getTotalHcoVisitsCount`, { params: myParams })
  }

  getHcpGiveaways(dateFrom, dateTo, hcpId?) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('hcpId', hcpId == undefined ? "" : hcpId);
    return this.http.get(`${this.configurations.apiAddress}/api/visits/getHcpGiveaways`, { params: myParams })
  }

  getHcoGiveaways(dateFrom, dateTo, hcoId?) {
    let myParams = new HttpParams()
      .set('dateFrom', dateFrom == undefined ? "" : dateFrom.toDateString())
      .set('dateTo', dateTo == undefined ? "" : dateTo.toDateString())
      .set('hcoId', hcoId == undefined ? "" : hcoId);
    return this.http.get(`${this.configurations.apiAddress}/api/visits/getHcoGiveaways`, { params: myParams })
  }

}
